import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

@Component({
  selector: 'gs-dialog',
  templateUrl: './GSDialog.html',
  styleUrls: ['./GSDialog.scss'],
})
export class GSDialogComponent extends AbstractComponent {
  public scope = {
    icon: '',
    confirmMessage: '',
    title: '',
    body: '',
    caption: '',
    buttons: [],
  };
  isCenter = true;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public parameter: any,
    private dialog: MatDialog
  ) {
    super();
    this.scope.icon = parameter.icon;
    this.scope.confirmMessage = parameter.confirmMessage;
    this.scope.title = parameter.title;
    this.scope.body = parameter.body;
    this.scope.caption = parameter.caption;
    this.scope.buttons = parameter.buttons;
    if (parameter.isActionButtonCenter) {
      this.isCenter = parameter.isActionButtonCenter;
    }
  }

  public onSubmit() {
    this.dialog.closeAll();
  }
}
